import { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [login, setLogin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    if(token) {
      try {
        const decodedToken = jwtDecode(token);
        setLogin({ token, id: decodedToken.id, role: decodedToken.role });
      } catch (error) {
        console.error('Erro ao decodificar token', error);
      }
    }
    setLoading(false);
  }, []);
  

  const loginContext = (token) => {
    localStorage.setItem('accessToken', token);
    const decodedToken = jwtDecode(token);
    setLogin({ token, id: decodedToken.id, role: decodedToken.role });
  };

  const logoutContextAdmin = () => {
    localStorage.removeItem('accessToken');
    setLogin(null);
    navigate('/login')
  };

  const logoutContextAuthor = () => {
    localStorage.removeItem('accessToken');
    setLogin(null);
    navigate('/autores/login')
  };

  return (
    <AuthContext.Provider value={{ login, loginContext, logoutContextAdmin, logoutContextAuthor, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);